import React, { useEffect, useRef, useState } from "react";
import { SearchContext } from "../../contexts/search/search.context";
import {
  SearchResultWrapper,
  ItemWrapper,
  SubmenuHeading,
  CategoryItems,
} from "./SearchBox.style";
import t from "../../i18n/translate";
import { logSearchQuery } from "../../services/googleAnalytics"
import { Avatar, Divider, Grid, makeStyles, Paper, Slide, Typography } from "@material-ui/core";
import { blue, blueGrey } from "@material-ui/core/colors";
import { useHistory } from 'react-router-dom';
import ProductIcon from '../../assets/images/delishop-favicons.png'
import { Spinner } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingLeft: theme.spacing(2),
    padding: '2px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    color: blueGrey[900],
    cursor: 'pointer',
    transition:'all 400 ease-in-out',
    '&:hover':{
      backgroundColor: 'rgba(156,197,75,.7)',
      fontWeight: 'bold',
    }
  },
  selected : {
    backgroundColor: 'rgba(156,197,75,.7)',
    fontWeight: 'bold',
  },
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    marginRight:'10px',
    boxShadow:'box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;',
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(4),
      height: theme.spacing(4),
    },
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    marginRight:'10px',
    boxShadow:'box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;',
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
  },
}));
const SearchResults = ({
  suggestions,
  itemStyle,
  wrapperStyle,
  setSuggestionValue,
  clearSearch,
  search,
  props
}) => {
  const classes = useStyles()
  const { state, searchdispatch } = React.useContext(SearchContext);
  const setSuggestion = (suggestion) => {
    console.log("Selected sub cat ", suggestion);
    logSearchQuery(state.text)
    if (window.location.pathname === "/") {
      localStorage.setItem("sug_sub_cat_id", suggestion);
    }
    searchdispatch({
      type: "SUGGESTION",
      payload: {
        ...state,
        suggestion,
      },
    });
    setSuggestionValue(suggestion);
    if (['/', '/express', "/favorites"].includes(window.location.pathname) || (window.location.pathname).includes('/campaign/')) {
      if (localStorage.getItem("expressMode")) {
        window.location.href = `/express/search/${search}`;
      } else {
        window.location.href = `/search/${search}`;
      }
    } else if(!(window.location.pathname).includes('/search')) {
      window.location.href = `/search/${search}`;
    }
  };
  const {items,list_brands,list_categories,list_subcategories} = props.suggestionItems
  const [selectedItem, setSelectedItem] = useState(null);
  const [newItems,setNewItems] = useState(items);
  const itemRefs = useRef([]);
  const history  = useHistory();
  const handleKeyDown = (e) => {
    setSelectedItem((prevSelectedItem) => {
      const currentIndex = newItems.findIndex(item => item.item_id === prevSelectedItem?.item_id);
      let newSelectedItem = prevSelectedItem || newItems[0];
      if (e.key === 'ArrowDown') {
        const nextIndex = (currentIndex + 1) % newItems.length; // Wrap around to the start if at the end
        newSelectedItem = newItems[nextIndex];
        scrollIntoView(nextIndex);
        focusItem(nextIndex)
      } else if (e.key === 'ArrowUp') {
        const prevIndex = (currentIndex - 1 + newItems.length) % newItems.length; // Wrap around to the end if at the start
        newSelectedItem = newItems[prevIndex];
        scrollIntoView(prevIndex);
        focusItem(prevIndex)
      } else if (e.key === 'Enter' && prevSelectedItem !== null) {
          if (['/', '/express', "/favorites"].includes(window.location.pathname) || (window.location.pathname).includes('/campaign/')) {
            // window.removeEventListener('keydown', handleKeyDown);
            window.location.href = `/product/${prevSelectedItem?.item_ref_id}`;
          }
      }
  
      return newSelectedItem;
    });
  };

  let searchQuery = localStorage.getItem('search_query') || search;
  const handleClickItem = (item, type = 'item') => {
    switch (type) {
      case 'item':
      localStorage.setItem("sub_cat_id", item.sub_cat_id);
      localStorage.setItem("mode", 'subcatoos');
      // window.location.href = `/product-suggestion/${item.item_ref_id}`;
      const deepLink = `/product/${item.item_ref_id}`;
      history.replace(deepLink);
      window.location.reload();
      break;
      case 'cat':
        setSuggestionValue(state.text)
        localStorage.setItem("sug_sub_cat_id", item.sub_cat_id);
        localStorage.setItem('mode','search');
        localStorage.setItem('search_query',state.text);
        localStorage.setItem("sub_cat_id", item.sub_cat_id);
        window.location.href = `/search/${state.text}?sub_cat_id=${item.sub_cat_id}`;
        break;
      case 'brand':
        setSuggestionValue(state.text)
        localStorage.setItem('mode','search');
        localStorage.setItem('search_query',state.text);
        localStorage.setItem("sug_sub_cat_id", item.sub_cat_id);
        localStorage.setItem("cat_id", item.cat_id);
        localStorage.setItem("sub_cat_id", item.sub_cat_id);
        window.location.href = `/brand/${item.brand_ref_id}`;
        break;
      default:
        break;
    }
  };
  // Helper function to focus the selected item
  const focusItem = (index) => {
    if (itemRefs.current[index]) {
      itemRefs.current[index].focus();
    }
  };
  
  // Helper function to scroll the selected item into view
  const scrollIntoView = (index) => {
    const element = document.getElementById(`item-${newItems[index]?.item_id}`);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };
  const handleMouseEnter = () => {
    window.addEventListener('keydown', handleKeyDown);
  };

  const handleMouseLeave = () => {
    window.removeEventListener('keydown', handleKeyDown);
  };
  useEffect(() => {
    setNewItems(items)
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [items]);
  
  useEffect(() => {
    if(window.location.pathname.includes('/search')){
      let query = window.location.pathname.trim().split('/');
      console.log(query)
      localStorage.setItem('search_query', query[2])
    }
  },[search]);
  return (
    <SearchResultWrapper onMouseLeave={handleMouseLeave}  onMouseEnter={handleMouseEnter} onKeyDown={handleKeyDown}
    {...wrapperStyle}>
      <SubmenuHeading>
        <h3>{t("search_item_suggestion_label")}</h3>
        <button onClick={clearSearch}>
          {t("shop_item_filter_clear_button")}
        </button>
      </SubmenuHeading>
      {/* {suggestions &&
        state.text !== "" &&
        suggestions.map((suggestion) => (
          <ItemWrapper
            {...itemStyle}
            key={suggestion.sub_cat_id}
            onClick={() => setSuggestion(suggestion.sub_cat_id)}
          >
            <strong>`{state.text}`</strong> {`${ t('search_item_suggestion_in_label', false) } `}
            <strong>`{suggestion.sub_cat_name}`</strong>
          </ItemWrapper>
        ))} */}
      {!!props.suggestion_loading ? 
        <div className="d-flex align-items-center justify-content-center">
          <Spinner animation="border" style={{color: "#9cc54b"}}/>
        </div>
        :<CategoryItems  tabIndex="0" onKeyDown={handleKeyDown}>
          {list_categories.length > 0 && (
            <>
              <Grid container spacing={0}>
                {list_subcategories.map((item, index) => (
                  item.name !== "" && (<Slide in={true} onClick={() => handleClickItem(item,'cat')}>
                    <Grid item xs={12}>
                      <Paper elevation={0} className={classes.paper}>
                        <Avatar
                          variant="square"
                          alt={item.name}
                          src={item.sub_image || ProductIcon}
                          className={classes.large}
                        />
                        <Typography variant="p" component="p" align="left">
                          Search {`${ t('search_item_suggestion_in_label', false) } `} Category 
                          <strong>`{item.name}`</strong>
                        </Typography>
                      </Paper>
                    </Grid>
                  </Slide>)
                ))}
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            </>
          )}
          {list_brands.length > 0 && (
            <>
              <Grid container spacing={0}>
                {list_brands.map((item, index) => (
                  item.name !== "" && (<Grid item xs={12} onClick={() => handleClickItem(item,'brand')}>
                    <Paper elevation={0} className={classes.paper}>
                      <Avatar
                        alt={item.name}
                        src={item.image || ProductIcon}
                        className={classes.large}
                      />
                      <Typography variant="p" component="p" align="left">
                        {item.name}
                      </Typography>
                    </Paper>
                  </Grid>)
                ))}
              </Grid>
              <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
            </>
          )}
          <Grid onKeyDown={handleKeyDown} container spacing={0}>
            {items.map((item, index) => (
              <Slide in={true} 
                key={item.item_id}
                tabIndex={0}
                id={`item-`+item.item_id}
                onClick={() => {
                  handleClickItem(item,'item')
                }}
              >
                <Grid item xs={12}>
                  <Paper
                    key={index}
                    elevation={0}
                    className={`${classes.paper} ${
                      item.item_id == selectedItem?.item_id
                        ? classes.selected
                        : ""
                    }`}
                  >
                    <Avatar
                      variant="square"
                      alt={item.name}
                      src={item.default_image_url || ProductIcon}
                      className={classes.small}
                    />
                    <Typography style={{fontSize:"14px"}} component="p" align="left">
                      {item.name}
                    </Typography>
                  </Paper>
                </Grid>
              </Slide>
            ))}
          </Grid>
        </CategoryItems>
      }
    </SearchResultWrapper>
  );
};

export default SearchResults;
